export default function Loading() {
    return (
        <div className="aa-PanelLayout">
            <div className="d-flex flex-column justify-content-center align-items-center text-center p-4">
                <h2 className="mt-4 display-4">Loading...</h2>
            </div>
        </div>
    )
}
